module.exports = __webpack_public_path__ + "static/media/sync_icon_transparent.c17729ab.png";